import ChevronUp from './ChevronUp'

export default ChevronUp
// eslint-disable-next-line import/export
export * from './ChevronUp'
